<his-plam *ngIf="!readonly">
    <p-inputNumber *ngIf="currency; else noCurrency" #content [hisDdKey]="i18nIdentifier" class="inputWidth100"
        [required]="isMandatory()" [(ngModel)]="value" [minFractionDigits]="minFractionDigits"
        [maxFractionDigits]="maxFractionDigits" [min]="min" [max]="max" [mode]="mode" [currency]="currency"
        [locale]="locale" (ngModelChange)="onModelChange($event)">
    </p-inputNumber>
    <ng-template #noCurrency>
        <p-inputNumber #content class="inputWidth100" [hisDdKey]="i18nIdentifier" [required]="isMandatory()"
            [(ngModel)]="value" [minFractionDigits]="minFractionDigits" [maxFractionDigits]="maxFractionDigits"
            [min]="min" [max]="max" [mode]="mode" [locale]="locale" [prefix]="prefix" [suffix]="suffix" 
            (ngModelChange)="onModelChange($event)">
        </p-inputNumber>
    </ng-template>
</his-plam>

<div *ngIf="readonly && value" class="layoutBlock detailPresentationListItem">
    <div class="columnDetailLabel detailPresentationListLabel">
        <span>{{ i18nIdentifier | hisUi }}</span>
    </div>
    <div class="columnDetailContent detailPresentationListContent">
        <span>{{value}}</span>
    </div>
</div>
